import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { Validators } from "@angular/forms";
import { Location } from "@angular/common";
import { MessageService, SelectItem } from "primeng/api";
import { Router, ActivatedRoute } from "@angular/router";
import { FechasService } from "src/app/services/fechas/fechas";
import { GenericService } from "../../../services/generic/generic.service";
import { siEsNull } from "src/app/config/texto_comprobacion";
import { HttpClient } from "@angular/common/http";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-proveedores-create",
  templateUrl: "./proveedores-create.component.html",
  styleUrls: ["./proveedores-create.component.css"],
})
export class ProveedoresCreateComponent implements OnInit {
  public user_email = "stalin.ac.developer@gmail.com";
  public api_token =
    "-yeXI60ehe5A9ABjR6XkQQrl2X-f8jSIxB4Qpxs0YnE9EzSRZZpJL5Wxfvd6i3ZVQYE";
  public auth_token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InVzZXJfZW1haWwiOiJzdGFsaW4uYWMuZGV2ZWxvcGVyQGdtYWlsLmNvbSIsImFwaV90b2tlbiI6Ii15ZVhJNjBlaGU1QTlBQmpSNlhrUVFybDJYLWY4alNJeEI0UXB4czBZbkU5RXpTUlpacEpMNVd4ZnZkNmkzWlZRWUUifSwiZXhwIjoxNzM3MTkyMTQ3fQ.pioykDKHSIeNXLGwozd3qgshS2UwxujGw8TPDHTTLOY";
  

  public countries: SelectItem[] = [{ label: "...", value: null }];
  public provinces: SelectItem[] = [{ label: "...", value: null }];
  public cities: SelectItem[] = [{ label: "...", value: null }];

  public countrySelected: any;

  public proveedorForm: UntypedFormGroup = new UntypedFormGroup({
    nombre: new UntypedFormControl("", Validators.required),
    eliminado: new UntypedFormControl("0"),
    cif: new UntypedFormControl(""),
    direccion: new UntypedFormControl(""),
    cp: new UntypedFormControl(""),
    localidad: new UntypedFormControl(""),
    provincia: new UntypedFormControl(""),
    pais: new UntypedFormControl(""),
    telefono: new UntypedFormControl(""),
    email: new UntypedFormControl(""),
    pasaporte_fito: new UntypedFormControl(""),
    precio_transporte: new UntypedFormControl(""),
    abv: new UntypedFormControl(""),
    codigo: new UntypedFormControl(""),
  });

  public database = "proveedores";
  public update: boolean = false;
  public id = "";
  public noGrabar: boolean = false;

  constructor(
    private location: Location,
    private messageService: MessageService,
    private genericService: GenericService,
    private _fechaService: FechasService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
    const cookieExist = this.cookieService.check("auth_token_countries");

    if (cookieExist) {
      this.auth_token = this.cookieService.get("auth_token_countries");

      this.getCountries()
        .toPromise()
        .then((response: any) => {
          if (response != null) {
            for (let i = 0; i < response.length; i++) {
              const element = response[i];
              this.countries.push({
                label: element["country_name"],
                value: element["country_name"],
              });
            }
          }
        })
        .catch((error) => {
          if (error.error.name === "TokenExpiredError") {
            this.getAuthToken(this.api_token, this.user_email).subscribe(
              (response: any) => {
                this.auth_token = response.auth_token;
                // cookie expira en 1 dia
                this.cookieService.set(
                  "auth_token_countries",
                  this.auth_token,
                  1
                );
              }
            );
          } else {
            console.log(error);
          }
        });
    } else {
      this.getAuthToken(this.api_token, this.user_email).subscribe(
        (response: any) => {
          this.auth_token = response.auth_token;
          this.cookieService.set("auth_token_countries", this.auth_token, 1);
        }
      );

      this.getCountries()
        .toPromise()
        .then((response: any) => {
          if (response != null) {
            for (let i = 0; i < response.length; i++) {
              const element = response[i];
              this.countries.push({
                label: element["country_name"],
                value: element["country_name"],
              });
            }
          }
        });
    }

    this.route.params.subscribe((data) => {
      if (data.id == undefined) {
        this.iniciar(null);
      } else {
        this.id = data.id;
        this.update = true;
        this.genericService
          .getId(this.id, this.database)
          .toPromise()
          .then((resp: any) => {
            this.iniciar(resp[0]);
          })
          .catch((error) => {
            console.log("error", error);
          });
      }
    });
  }

  iniciar(value) {
    let proveedor = value;

    if (proveedor != null) {
      for (const key in proveedor) {
        if (key.localeCompare("id") == 0) {
        } else {
          if (key.includes("fecha")) {
            this.proveedorForm
              .get(key)
              .patchValue(this._fechaService.fechaUpdate(proveedor[key]));
          } else {
            this.proveedorForm.get(key).patchValue(siEsNull(proveedor[key]));
          }
        }
      }
    }
  }

  getAuthToken(api_token, user_email) {
    return this.http.get(
      "https://www.universal-tutorial.com/api/getaccesstoken",
      {
        headers: {
          Accept: "application/json",
          "api-token": api_token,
          "user-email": user_email,
        },
      }
    );
  }

  getCountries() {
    return this.http.get("https://www.universal-tutorial.com/api/countries/", {
      headers: {
        Authorization: "Bearer " + this.auth_token,
        Accept: "application/json",
      },
    });
  }

  getProvinces(country) {
    

    if (country.value != undefined || country.value.length > 0) {
      this.http
        .get("https://www.universal-tutorial.com/api/states/" + country.value, {
          headers: {
            Authorization: "Bearer " + this.auth_token,
            Accept: "application/json",
          },
        })
        .subscribe((response: any) => {
          for (let i = 0; i < response.length; i++) {
            const element = response[i];
            this.provinces.push({
              label: element["state_name"],
              value: element["state_name"],
            });
          }
        });
    }
  }

  getCities(province) {
    if (province.value != undefined || province.value.length > 0) {
      this.http
        .get(
          "https://www.universal-tutorial.com/api/cities/" + province.value,
          {
            headers: {
              Authorization: "Bearer " + this.auth_token,
              Accept: "application/json",
            },
          }
        )
        .subscribe((response: any) => {
          for (let i = 0; i < response.length; i++) {
            const element = response[i];
            this.cities.push({
              label: element["city_name"],
              value: element["city_name"],
            });
          }
        });
    }
  }

  regresar() {
    this.location.back();
  }

  onSubmit() {
    this.noGrabar = true;
    let data = [{}];
    data[0]["id"] = this.id || "0";

    for (const key in this.proveedorForm.value) {
      data[0][key] = this.proveedorForm.value[key];
    }

    if (this.update) {
      this.genericService
        .update(data[0], this.database)
        .toPromise()
        .then((resp: any) => {
          this.messageService.add({
            severity: "success",
            summary: "Registro",
            detail: "Registro actualizado correctamente",
          });

          setTimeout(() => {
            this.router.navigate(["/dashboard/proveedores"]);
          }, 2000);
        })
        .catch((error) => {
          console.log("error proveedores", error);
        });
    } else {
      this.genericService
        .create(data[0], this.database)
        .toPromise()
        .then((resp: any) => {
          this.messageService.add({
            severity: "success",
            summary: "Registro",
            detail: "Registro creado correctamente",
          });

          setTimeout(() => {
            this.router.navigate(["/dashboard/proveedores"]);
          }, 2000);
        })
        .catch((error) => {
          console.log("Error Proveedores, error");
        });
    }
  }
}
